class UrlHelper {
    getCommandsApiUrl() {
        return "https://kajr7f673f.execute-api.eu-west-1.amazonaws.com/prod/api/commands";
    }
}

export default new UrlHelper();